<template>
  <div class="g-wrapper" id="g-wrapper">
    <!--header-->
    <headerDiv></headerDiv>
    <!--/header-->
    <!--main content-->
    <router-view :dbList="this.dbList" :indexList="this.indexList" :listLimit="this.listLimit"></router-view>
    <!--/main content-->
    <!--footer-->
    <footerDiv/>
    <!--/footer-->
    <p class="g-back-to-top"><a class="j-scroll" href="#g-wrapper"><span class="g-clip">{{ $t("Site.back_to_top") }}</span><i class="g-i g-i-arrow" aria-hidden="true"></i></a></p>
  </div>
</template>

<script>
/* eslint-disable no-console */
// @ is an alias to /src
import headerDiv from '@/components/header.vue'
import footerDiv from '@/components/footer.vue'

import i18n from '@/i18n.js'

import { Backend } from '@/ajax/Backend'
const DBs = Backend.get('dbs')
const Indices = Backend.get('indices')

export default {
  name: 'app',
  components: {
    headerDiv,
    footerDiv
  },
  data () {
    return {
      dbListAll: {},
      indexListAll: {},
      listLimit: [25, 50, 100]
    }
  },
  computed: {
    dbList () {
      const dbs = []
      Object.keys(this.dbListAll).forEach(function (key) {
        if (i18n.locale == 'en') {
          dbs.push({id: key, text: this.dbListAll[key].en})
        } else {
          dbs.push({id: key, text: this.dbListAll[key].ja})
        }
      }.bind(this));
      return dbs
    },
    indexList () {
      const indices = []
      Object.keys(this.indexListAll).forEach(function (key1) {
        const index = {}
        index.id = key1
        index.text = i18n.t('Index.'+key1)
        index.children = []
        Object.keys(this.indexListAll[key1]).forEach(function (key2) {
          if (i18n.locale == 'en') {
            index.children.push({id: key2, text: this.indexListAll[key1][key2].en})
          } else {
            index.children.push({id: key2, text: this.indexListAll[key1][key2].ja})
          }
        }.bind(this));
        indices.push(index)
      }.bind(this));
      return indices
    },
  },
  created: function() {
    this.getDBs()
    this.getIndices()
  },
  methods: {
    getDBs() {
      // データベース情報取得
      DBs.get()
        .then(function(response) {
          if (!response.data.info) {
            console.log(response.data)
          } else if (response.data.info.status === 'failure') {
            console.log(response.data.info.message)
          } else {
            this.dbListAll = response.data.dbs
          }
        }.bind(this))
        .catch(err => console.log(err))
    },
    getIndices() {
      // 索引情報取得
      Indices.get()
        .then(function(response) {
          this.indexListAll = response.data
        }.bind(this))
        .catch(err => console.log(err))
    },
  }
}
</script>